import React from 'react';

import { DatePickerProps } from 'antd/lib/date-picker';

import * as Styled from './DatePicker.style';

export type Props = DatePickerProps;
export const DatePicker = (props: Props): JSX.Element => <Styled.DatePicker {...props} />;
